'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from '@spa/components/wishlists/wishlists.component';
import dynamic from 'next/dynamic';

const DynamicWishlistsComponent: ComponentType<Props> = dynamic(
  () => import('./wishlists.component')
);

export default DynamicWishlistsComponent;

export function calculateWishlistsPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 250 },
    { sinceWidth: 325, height: 256 },
    { sinceWidth: 425, height: 296 },
    { sinceWidth: 525, height: 336 },
    { sinceWidth: 625, height: 376 },
    { sinceWidth: 768, height: 324 },
    { sinceWidth: 1024, height: 384 },
    { sinceWidth: 1442, height: 481 }
  ];

  return { heightSinceWidth };
}
